import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userLogin } from '../../../../actions/user.js';
import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage.js';
import { authorize } from '../../../../businessLogic/authorizator.js';
import { isAnyInputFormVisible, isAnyOverlayFormVisible } from '../../../../businessLogic/form';
import { ValidMe, forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import ForgotPasswordPage from '../../../../containers/ForgotPasswordPage.js';
import ResetPasswordTokenPage from '../../../../containers/ResetPasswordTokenPage.js';
import { updateShowforgetPasswordModal, updateShowResetPasswordTokenModal } from '../../../../actions/modal';
import ShowOrHidePassText, { PasswordHint } from 'businessLogic/showOrHidePassText.js';

const UserLogin = () => {
  const dispatch = useDispatch();
  const [keepMeLoggedIn, setKeepMeLoggedIn] = useState(false);
  const [readyToRenderQuickView, setReadyToRenderQuickView] = useState(false);
  const [loginClasses, setLoginClasses] = useState(
    'ui labeled icon button color-button color-button-hover color-white left-text max-width'
  );
  const [enableTimerValidation, setEnableTimerValidation] = useState(false);
  const [showPasswordHint, setShowPasswordHint] = useState(false); // Not maintain this value when page refresh
  const fetchingLogin = useSelector((state) => state.usersReducer.fetchingLogin);
  const fetchingUserProfileAfterLogin = useSelector((state) => state.usersReducer.fetchingUserProfileAfterLogin);
  const userHasWaitingAreas = useSelector((state) => state.usersReducer.userHasWaitingAreas);
  const waitingAreas = useSelector((state) => state.waitingAreaReducer.waitingAreas);
  const showForgetPasswordModal = useSelector((state) => state.modalReducer.showForgetPasswordModal);
  const resetPasswordToken = useSelector((state) =>
    state.usersReducer.resetPassword ? state.usersReducer.resetPassword.resetPasswordToken : ''
  );
  const userProfile = useSelector((state) => state.usersReducer.userProfile);
  let UserNameInput = '';
  let PasswordInput = '';
  const [loadingClass, setLoadingClass] = useState('');

  useEffect(() => {
    let newClass =
      fetchingLogin || fetchingUserProfileAfterLogin ? loginClasses + ' loading' : loginClasses.replace(' loading');
    setLoginClasses(newClass);
    setReadyToRenderQuickView(readyToRenderQuickView);
    setLoadingClass('');
    //checking if token is there and isValid:
    if (resetPasswordToken && resetPasswordToken != null) {
      var currentDateClient = new Date();
      if (currentDateClient >= resetPasswordToken.ExpiryTimeLocal) {
        //if link is expired show the forgot password page
        dispatch(updateShowforgetPasswordModal(true));
        history.pushState(null, '', location.href.split('?')[0]); //clearing the query string for reset password
        console.log('Reset token not valid showing forgot Password Modal');
      } else {
        //the token is valid and now we will display the reset password from token page
        dispatch(updateShowResetPasswordTokenModal(true));
        console.log('opening reset token modal');
      }
    }
    window.$(document.body).on('keydown', handleEnterForLogin);

    return () => {
      window.$(document.body).off('keydown', handleEnterForLogin);
    };
  }, []);

  useEffect(() => {
    if (fetchingUserProfileAfterLogin === true && userHasWaitingAreas === false) {
      setLoginClasses(loginClasses.replace(' loading', ' error-shaking'));
      setTimeout(() => {
        setLoginClasses(loginClasses.replace(' error-shaking', ''));
      }, 200);
      setLoadingClass(loadingClass.replace(' loading', ' error-shaking'));
      setTimeout(() => {
        setLoadingClass(loadingClass.replace(' error-shaking', ''));
      }, 200);
    }
  }, [fetchingUserProfileAfterLogin, userHasWaitingAreas]);

  const handleKeepMeSignedInChange = () => {
    setKeepMeLoggedIn(!keepMeLoggedIn);
  };

  const handlePasswordChange = (value) => {
    setEnableTimerValidation(true);
  };

  const handleLoginButtonClick = (e) => {
    if (!isAnyOverlayFormVisible() && !isAnyInputFormVisible()) {
      dispatch(hideGlobalMessage());
      window.fetchPromiseController = null;
      let areThereErrors = forceValidation(undefined, undefined, 'loginForm');
      if (!areThereErrors) {
        setLoadingClass('loading');
        let callback = (data) => {
          let doNotRedirect = true;
          setShowPasswordHint(false);
          //if the user wanted to go somewhere else, do not bother with the quick view modal
          if (
            sessionStorage.getItem('userWantedPage') == 'undefined' ||
            sessionStorage.getItem('userWantedPage') == null
          ) {
            authorize(data, dispatch, doNotRedirect);

            // TODO - after PR1, the setState should be enabled again
            // setState({
            //   loggedInUserHandler: () => {
            //     dispatch(userLoggedInProcessFinished());
            //   }
            // });
          } else {
            authorize(data, dispatch);
          }
        };

        let error = (err) => {
          if (err == 401 || err.toLowerCase() == 'unauthorized') {
            dispatch(
              displayGlobalMessage({
                text: APP.LANGUAGE.Login.LoginError.replace(
                  '##IncorrectMaxLoginAttempts##',
                  window.APP.CONFIGURATION.INCORRECT_MAX_LOGIN_ATTEMPTS || 3
                ),
                visible: true,
                messageType: 'Bad',
              })
            );
          }
          setLoginClasses(loginClasses + ' error-shaking');
          setLoadingClass('');
          setShowPasswordHint(true);
          setTimeout(() => {
            //remove effect after 200ms
            setLoginClasses(loginClasses.replace(' error-shaking', ''));
          }, 200);
          if (err == 'AuthenticateIsLocked') {
            dispatch(
              displayGlobalMessage({
                text: APP.LANGUAGE.ServerErrors.AuthenticateIsLocked.replace(
                  '##IncorrectAttemptLockDuration##',
                  window.APP.CONFIGURATION.INCORRECT_ATTEMPT_LOCK_DURATION || 10
                ),
                visible: true,
                messageType: 'Bad',
              })
            );
          }
        };

        dispatch(
          userLogin(
            {
              username: getUserName(),
              password: getPassword(),
              rememberMe: keepMeLoggedIn,
            },
            callback,
            error
          )
        );
      }
    }
  };

  const pop = (event) => {
    window.$(event.target).toggleClass('wdtm htxl');
  };
  const openPageHelp = () => {
    window.open(APP.EXTERNAL_LINKS.Login.Help, '_blank');
  };

  const getUserName = () => {
    return document.getElementById('usernameInput').value;
  };

  const getPassword = () => {
    return document.getElementById('passwordInput').value;
  };

  const handleEnterForLogin = (event) => {
    if (event.which == 13 && showForgetPasswordModal != true) window.$('button[data-group="loginForm"]').click();
  };

  const showForgotPasswordModal = (event) => {
    event.preventDefault();
    dispatch(updateShowforgetPasswordModal(true));
    clearAllValidationErrors(false); //passing disableActionButton = false as param. if false we will not be disabling the action buttons.
  };

  const openAccessToProgramPage = () => {
    window.open(APP.EXTERNAL_LINKS.Login.AccessToProgram, 'mgt-console');
  };

  if (userProfile?.email?.length > 0) {
    //means the user is logged in so stop showing the login form
    window.$('#overlay').show();
    return <div className="login" />;
  }

  return (
    <div className="login">
      <ForgotPasswordPage />
      <ResetPasswordTokenPage userEmail={resetPasswordToken ? resetPasswordToken.userEmail : ''} />
      {!window.hideUnfinishedItems ? (
        <i onClick={openPageHelp} className="ui icon help circle fr text-size-xl mrts mrrl hand color-white" />
      ) : (
        ''
      )}
      <form
        className="ui form "
        onSubmit={() => {
          return false;
        }}
      >
        <img className="ui image mrbxl" src={window.APP.IMAGES.ApplicationLogo} />

        <ValidMe
          validmefor="email"
          group="loginForm"
          fieldClasses=" pdbxs"
          enableTimerOnInitalRender={enableTimerValidation}
          requiredCustomMessage={window.APP.LANGUAGE.Errors.EnterYourEmail}
        >
          <Txt
            focusme="true"
            ref={(input) => {
              UserNameInput = input;
            }}
            id="usernameInput"
            tabIndex="1"
            noTitle
            placeholder={APP.LANGUAGE.Login.EmailPlaceholder}
          />
        </ValidMe>
        <ValidMe
          validmefor="required"
          group="loginForm"
          fieldClasses={showPasswordHint ? ' mrbxs' : ''}
          enableTimerOnInitalRender={enableTimerValidation}
          requiredCustomMessage={window.APP.LANGUAGE.Errors.EnterYourPassword}
        >
          {showPasswordHint && getPassword() !== '' ? <ShowOrHidePassText elementId="passwordInput" /> : <div />}
          <Txt
            ref={(input) => {
              PasswordInput = input;
            }}
            id="passwordInput"
            tabIndex="2"
            noTitle
            onChange={handlePasswordChange}
            placeholder={APP.LANGUAGE.Login.PasswordPlaceholder}
            type="password"
          />
        </ValidMe>
        {showPasswordHint ? <PasswordHint showPasswordHint={showPasswordHint} /> : ''}
        <Txt
          checkbox
          tabIndex="3"
          onChange={handleKeepMeSignedInChange}
          text={APP.LANGUAGE.Login.KeepMeLoggedIn}
          classes="mrbm "
        />

        <button
          tabIndex="4"
          type="button"
          onClick={handleLoginButtonClick}
          data-group="loginForm"
          className={`${loginClasses} ${loadingClass}`}
        >
          <i className="sign in icon" />
          {APP.LANGUAGE.Login.LoginButton}
        </button>
        <a tabIndex="5" className=" color-login-links  mrrs mrtm" href="#" onClick={showForgotPasswordModal}>
          {APP.LANGUAGE.Login.ResetPassword}
        </a>
        <a tabIndex="6" className=" color-login-links mrrs" href="#" onClick={openAccessToProgramPage}>
          {APP.LANGUAGE.Login.DontHaveAnAccount}
        </a>
        <div className="center-with-margin margin-footer">
          <img className="ui image footer-img" src={window.APP.IMAGES.FooterLogoImg} />
          <a
            tabIndex="7"
            className="mrrs mrtm footer-text color-footer-links"
            href={window.APP.EXTERNAL_LINKS.Login.FooterHyperLink}
            target="_blank"
          >
            {window.APP.EXTERNAL_LINKS.Login.FooterText}
          </a>
        </div>
      </form>
    </div>
  );
};

export default UserLogin;
